import React from "react";
import NumberInput from "./NumberInput.jsx";

export default class MeasureNumberInput extends NumberInput {

    getUnitFactor() {
        return STAGE.settings.ruler.scale;
    }

    getUnit() {
        return STAGE.settings.ruler.unit;
    }

    getDecimals() {
        return STAGE.settings.ruler.fixed;
    }

}
